"use client";

import React from "react";
import { useSelector } from "react-redux";

export default function KbvHeadTableOdds() {
  const oddsPeriod = useSelector((state) => state.oddsPeriodReducer) || "full";
  const isHalf1 = oddsPeriod === "half1";

  return (
    <div
      className="kbv-head-table-bg mb-hidden md:flex text-center sticky top-0 z-[2] rounded-t-lg font-semibold text-[13px] text-white border-white [&>*]:flex [&>*]:items-center [&>*]:justify-center [&>*]:border-r [&>*]:border-white [&>*]:border-t-0 [&>*]:border-b-0"
    >
      <div className="w-[10%] justify-center flex-wrap rounded-tl-lg">
        Giờ
      </div>
      <div className={`${isHalf1 ? "w-[55%]" : "w-[22%]"} text-left font-bold justify-start`}>
        <div>Trận Đấu</div>
      </div>
      {!isHalf1 && (
        <div className="w-[35%] flex flex-col min-w-0 border-r border-white">
          <div className="border-t-0 pt-2.5 pb-2.5 flex items-center justify-center">Cả Trận</div>
          <div className="flex flex-row w-full min-h-0 [&>*]:flex-1 [&>*]:min-w-0 [&>*]:border-r [&>*]:border-t [&>*]:border-white [&>*]:border-b-0 [&>*]:flex [&>*]:items-center [&>*]:justify-center [&>*]:self-stretch">
            <div>Tỷ lệ</div>
            <div>Tài xỉu</div>
            <div className="!border-r-0">1x2</div>
          </div>
        </div>
      )}
      <div className="w-[35%] flex flex-col min-w-0 border-r-0">
        <div className="border-t-0 pt-2.5 pb-2.5 flex items-center justify-center">Hiệp 1</div>
        <div className="flex flex-row w-full min-h-0 [&>*]:flex-1 [&>*]:min-w-0 [&>*]:border-r [&>*]:border-t [&>*]:border-white [&>*]:border-b-0 [&>*]:flex [&>*]:items-center [&>*]:justify-center [&>*]:self-stretch">
          <div>Tỷ lệ</div>
          <div>Tài xỉu</div>
          <div className="!border-r-0">1x2</div>
        </div>
      </div>
    </div>
  );
}
